

/**
 * 从一个数组里移除对应id的元素
 * @param arr: Array<object>
 * @param ids: Array<string>
 * @returns
 */
export const filterArrayWithIds = (arr, ids) => {
    if (!Array.isArray(arr) || !Array.isArray(ids) || ids.length === 0) {
        return arr;
    }
    return arr.filter(item => item && !ids.includes(item.id));
};
